import { TieUp } from './tie_up';

export class Common {
  cantSelectShipping?: boolean;

  currentTimeEpoch?: number;

  switchingTimeEpoch?: number;

  tieUp?: TieUp[];

  constructor(init?: Partial<Common>) {
    Object.assign(this, init);

    // `tieUp` のマッピング
    if (init?.tieUp) {
      this.tieUp = init.tieUp.map(tieUpItem => new TieUp(tieUpItem));
    }
  }
}
